<template>
    <a
        :class="classObject"
        :href="item.url"
    >
        <BaseImage
            :placeholder="item.placeholder"
            :srcset="item.image"
            :ratio="item.ratio"
        />
        <div class="NewsCard__container">
            <div class="NewsCard__date" v-if="item.displayDate && !twoDates">
                <strong>{{ item.displayDate.day }}</strong>
                <span>{{ item.displayDate.month }}</span>
            </div>
            <div v-if="twoDates" class="text--white mb-small">
                <span class="NewsCard__day">{{ item.displayStartDate.day }}</span>
                <span class="NewsCard__month">{{ item.displayStartDate.month }}</span>
                <span class="NewsCard__divider">⬤</span>
                <span class="NewsCard__day">{{ item.displayEndDate.day }}</span>
                <span class="NewsCard__month">{{ item.displayEndDate.month }}</span>
            </div>
            <div>
                <BaseTag
                    v-if="tag"
                    class="mr-min"
                    :title="tag"
                >
                </BaseTag>
                <BaseTag
                    v-if="deal"
                    class="BaseTag--squared"
                    :title="'DEAL'"
                >
                </BaseTag>
                <h2 class="uppercase text--white NewsCard__title">{{ title }}</h2>
                <h2 class="uppercase text--white NewsCard__title-truncated">{{ truncatedTitle }}</h2>
            </div>
        </div>
    </a>
</template>
<script>
import moment from 'moment';
export default {
    name: 'NewsCard',
    props: ['item', 'tag', 'isProduct', 'showDeals'],
    computed: {
        title() {
            return this.isProduct ? this.item.heading : this.item.title;
        },
        deal() {
            return this.item.deal &&
                this.showDeals && 
                this.item.deals && 
                this.item.deals.find((deal) => {
                    const start = moment(deal.start, "DD/MM/YYYY");
                    const end = moment(deal.end, "DD/MM/YYYY");
                    const now = moment();
                    return start.isBefore(now) && now.isBefore(end);
                });
        },
        truncatedTitle() {
            return this.title.length > 30 ? (this.title.slice(0, 30) + '...') : this.title;
        },
        classObject() {
            return {
                'NewsCard' : true,
                'NewsCard--event' : this.item.date !== null,
                'NewsCard--product' : this.isProduct
            }
        },
        twoDates() {
            return (this.item.displayStartDate && this.item.displayEndDate) &&
                (JSON.stringify(this.item.displayStartDate) != JSON.stringify(this.item.displayEndDate))
        },
    }
}
</script>
<style lang="scss" scoped>
    .NewsCard {
        display: block;
        position: relative;

        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: getColor('black');
            opacity: 0.15;
            transition: all ease-out 0.456s;
        }

        &:hover {
            &:after {
                opacity: 0.45;
            }
        }
    }

    .NewsCard__container {
        display: flex;
        align-items: flex-end;
        position: absolute;
        flex-direction: column;
        max-width: 100%;
        left: getSpacing('small');
        top: getSpacing('small');
        right: getSpacing('small');
        bottom: getSpacing('small');
        color: getColor('white');
        z-index: 1;

        @include media-query(lap) {
            left: getSpacing('spacer');
            top: getSpacing('spacer');
            right: getSpacing('spacer');
            bottom: getSpacing('spacer');
        }

        @include media-query(desk) {
            left: getSpacing('medium');
            top: getSpacing('medium');
            right: getSpacing('medium');
            bottom: getSpacing('medium');
        }

        .NewsCard--event & {
            align-items: flex-start;
            justify-content: space-between;
        }

        .NewsCard__title {
            align-self: stretch;
        }
    }

    .NewsCard__title-truncated {
        font-size: 14px;
        display: none;
    }

    .NewsCard--event {
        .NewsCard__date {
            strong {
                font-size: 2.7rem;

                @include media-query(lap-and-up) {
                    font-size: 6rem;
                }
            }
        }
        .NewsCard__title {
            @include media-query(smart) {
                display: none;
           }
        }

        .NewsCard__title-truncated {
            @include media-query(smart) {
                display: block;
                font-size: 12px;
            }
        }

        .BaseTag {
            @include media-query(smart) {
                font-size: 11px;
                margin-bottom: 5px;
            }
        }
    }

    .NewsCard__date {
        display: flex;
        font-family: $heading-font-family;
        text-transform: uppercase;
        align-self: stretch;

        strong {
            font-size: 5rem;
            height: 30px;
            line-height: 0.25;
            letter-spacing: -1px;

            @include media-query(lap-and-up) {
                font-size: 6rem;
                height: 67px;
            }
        }

        span {
            font-size: 1.25rem;
            @include media-query(lap-and-up) {
                font-size: 1.4rem;
            }
            @include media-query(tiny) {
                font-size: 1rem;
                margin-left: 3px;
            }
        }
    }

    .NewsCard__day {
        font-size: 2.1rem;
        line-height: 0;
        letter-spacing: -1px;
        font-family: $heading-font-family;
        text-transform: uppercase;

        @include media-query(lap-and-up) {
            font-size: 2.6rem;
        }

        @include media-query(tiny) {
            font-size: 1.3rem;
        }
    }

    .NewsCard__month {
        font-size: 0.8rem;
        font-size: 1.1rem;
        line-height: 0;
        vertical-align: top;
        text-transform: uppercase;
        letter-spacing: -1px;
        font-family: $heading-font-family;

        @include media-query(tiny) {
            font-size: 0.8rem;
            vertical-align: baseline;
        }
    }

    .NewsCard__divider {
        font-size: 3px;
        vertical-align: baseline;
        font-family: $heading-font-family;
        text-transform: uppercase;

        @include media-query(lap-and-up) {
            font-size: 6px;
            margin-left: 10px;
            margin-right: 10px;
            vertical-align: top;
        }
    }
    .BaseTag {
        display: inline-flex;
    }
</style>
